import LoginActionTypes from '../Utility/LoginActionTypes'
import AllActionTypes from '../../../Utility/AllActionTypes'
import { get, post, put, del } from '../../../Utility/Http';

export const setToken = (token, accessToken, expiresIn, refreshToken, session = '') => async (dispatch) => {
    dispatch({
        type: LoginActionTypes.SET_TOKEN,
        payload: token
    });
    dispatch({
        type: LoginActionTypes.SET_ACCESS_TOKEN,
        payload: accessToken
    });
    dispatch({
        type: LoginActionTypes.SET_TOKEN_EXPIRE_TIME,
        payload: expiresIn
    });
    dispatch({
        type: LoginActionTypes.SET_REFRESH_TOKEN,
        payload: refreshToken
    });
    dispatch({
        type: LoginActionTypes.SET_SESSION,
        payload: session
    });

}


export const logOutApp = (accessToken, token) => async (dispatch) => {
    del(`${process.env.EXTENDED_URL}users/signout`, "", { "Accesstoken": "", "Authorization": "" }).then((response) => {

    })
    dispatch({
        type: LoginActionTypes.LOGOUT,
        payload: { "token": "", "accessToken": "", "refreshToken": "", "expiresIn": { "loggedInTime": "", "expiryTime": "", "expiryInterval": "" }, "userCredentials": {}, "version": [], "roleWisePermission": {}, "session": "", "redirectInfo": null }
    });
    dispatch({
        type: AllActionTypes.CLEAR_DATA,
        payload: { "loaderState": false, "leftbar": false, "activeLink": { 'accName': "", 'activeClass': "" }, "roleWisePermission": {} }
    });
    dispatch({
        type: AllActionTypes.USER_SEARCH_DATA,
        payload: {
            destination: "",
            type: "",
            location: "",
            start_date: new Date(),
            end_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
            adult: 1,
            children: 0,
            children_age: [],
            selectedRoom: {},
            filterData: {}
        }
    });
}

export const setUserCredentials = (value) => async (dispatch) => {
    dispatch({
        type: LoginActionTypes.SET_USER_CREDENTIALS,
        payload: value
    });

}

export const setVersionList = (value) => async (dispatch) => {
    dispatch({
        type: LoginActionTypes.SET_VERSION,
        payload: value
    });

}

/**
 * Sets redirect information in Redux store
 * @param {object} redirectInfo - Object containing path and parameters for redirect
 */
export const setRedirectInfo = (redirectInfo) => async (dispatch) => {
    dispatch({
        type: LoginActionTypes.SET_REDIRECT_INFO,
        payload: redirectInfo
    });
}

/**
 * Clears redirect information from Redux store
 */
export const clearRedirectInfo = () => async (dispatch) => {
    dispatch({
        type: LoginActionTypes.SET_REDIRECT_INFO,
        payload: null
    });
}
